import { render, staticRenderFns } from "./SelectTemplate.vue?vue&type=template&id=2b335f8b"
import script from "./SelectTemplate.vue?vue&type=script&lang=js"
export * from "./SelectTemplate.vue?vue&type=script&lang=js"
import style0 from "./SelectTemplate.vue?vue&type=style&index=0&id=2b335f8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports